import { TestsBySectionSpecPage } from "./TestsBySectionSpecPage";

const LabTestsBySection = () => {
	return <TestsBySectionSpecPage />;
};
export default LabTestsBySection;
